import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import View from './view';
import Create from './create';
import Edit from './edit';
import WalletTransactions from './transactions';
import AdminWalletTopup from './amountadd';

export default class Wallet extends Component {
    render() {
        const { match } = this.props;
        return (
            <div id="layoutSidenav_content">
                <main>
                    <Switch>
                        <Route path={[`${match.path}/list`]} component={View} />
                        <Route path={[`${match.path}/create`]} component={Create} />
                        <Route path={[`${match.path}/edit`]} component={Edit} />
                        <Route path={[`${match.path}/transactions`]} component={WalletTransactions} />
                        <Route path={[`${match.path}/admin-topup`]} component={AdminWalletTopup} />
                    </Switch>
                </main>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/index.js